export default __webpack_public_path__ + "static/gallery5-eef2e8b8a2442d6a87a0ea7576548e12.png";